import React from 'react';
import ExpressionsPlaygroundPage from './pages/ExpressionsPlaygroundPage';
import { AuthWrapper } from '~src/components/AuthWrapper';

export const homeRoute = {
  name: 'home',
  path: '/',
  exact: true,
  component: () => <AuthWrapper component={<ExpressionsPlaygroundPage />} />,
};
